import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Link for a back arrow on the left of the title. */
  backTo?: string;
  /** Buttons on the right. */
  actions?: ReactNode;
}

export function PageHeader({ title, description, backTo, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex items-start gap-3">
        {backTo ? (
          <Button variant="ghost" size="icon" asChild className="-ml-2 mt-0.5">
            <Link to={backTo} aria-label="Back">
              <ArrowLeft />
            </Link>
          </Button>
        ) : null}
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
        </div>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
